module.exports = __webpack_public_path__ + "static/media/arrow_right.06e53fbe.svg";